import Dashboard from '../containers/dashboard'
import BanksAccountsManagement from '../containers/banks-accounts-management'

const BanksAccounts = () => {
  return (
    <Dashboard>
      <BanksAccountsManagement />
    </Dashboard>
  )
}

export default BanksAccounts
